import React from "react";

const HeaderBack = ({ label, onBack, right }) => (
  <div className="mb-4 flex min-h-9 items-center justify-between gap-3 px-1">
    <button
      type="button"
      onClick={onBack}
      className="inline-flex items-center gap-2 text-[0.9rem] font-black text-emerald-700"
    >
      <span className="text-xl leading-none">‹</span>
      {label}
    </button>
    {right}
  </div>
);

export default HeaderBack;
